export default class SliderArea {
  createSliderArea() {
    this.sliderArea = document.createElement('div');
    this.sliderArea.classList.add('slider-area');
    document.body.appendChild(this.sliderArea);
  }

  init() {
    this.createSliderArea();
  }
}
